export const sentryInitConfig = {
  debug: false, //  this will block all sentry related logs from going into debugger console,
  maxBreadcrumbs: 450, // latest 450 log will be recorded, this is needed to handle the payload limit on messages captured by sentry.
};
